import React, { useState, useEffect } from "react";
import { fetchItems, createItem } from "../api/networking";
import "./admin_modal.css"

const AdminModal = ({ modalOpen, selectedTask, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState();

  const [newRow, setNewRow] = useState({ key: "", value: "" });
  const [financialType, setFinancialType] = useState("")

  useEffect(() => {
    if (modalOpen && selectedTask) {
      loadTaskData();
      setFinancialType(selectedTask.financial_file_type)
    }
  }, [modalOpen, selectedTask]);

  const loadTaskData = async () => {
    setLoading(true);
    try {
      const response = await createItem('/get_temp_task_list',{ 
        stock_symbol:selectedTask.stock_symbol, 
        date_of_financial_data:selectedTask.date_of_financial_data, 
        financial_file_type:selectedTask.financial_file_type });
      // Assuming API returns array of objects [{key: 'Name', value: 'Value'}, ...]
      console.log("Api response",response[1])
      setTableData(response[1]);
      const jsonData = response[1];

      var listOfHeader = [];
      var listOfValues = [];
      const dataObject = Array.isArray(jsonData) ? jsonData[0] : jsonData;

        for (const key in dataObject) {
            if (dataObject.hasOwnProperty(key)) {
                console.log("Key:", key, "Value:", dataObject[key]);
                listOfHeader.push(key);
                listOfValues.push(dataObject[key]);
            }
        }


        setTableHeaders(listOfHeader);
        setTableData(listOfValues);
      console.log("List Of Headers: ", listOfHeader);
    console.log("List Of Values: ", listOfValues);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  

  const handleAddRow = () => {
    if (newRow.key && newRow.value) {
      setTableData([...tableData, newRow]);
      setNewRow({ key: "", value: "" });
    }
  };

  const handleApprove = async () => {

    const approvedData = {};

    for(let counter = 0; counter < tableHeaders.length; counter++){
        approvedData[tableHeaders[counter]] = tableData[counter];
    }
  
    console.log("Data to send:", approvedData);

    if(selectedTask.financial_file_type == "Balance Sheet"){
      try {
        await createItem("/modify_balance_table", {
          date: selectedTask.date_of_financial_data,
          symbol: selectedTask.stock_symbol,
          balance_sheet: approvedData });
        closeModal();
      } catch (err) {
        console.error(err);
      }
    }else if(selectedTask.financial_file_type == "Cashflow Sheet"){

      try {
        await createItem("/modify_cashflow_table", {
          date: selectedTask.date_of_financial_data,
          symbol: selectedTask.stock_symbol,
          cashflow_sheet: approvedData });
        closeModal();
      } catch (err) {
        console.error(err);
      }

    }else if(selectedTask.financial_file_type == "Income Sheet"){

      try {
        await createItem("/modify_income_table", {
          date: selectedTask.date_of_financial_data,
          symbol: selectedTask.stock_symbol,
          income_sheet: approvedData });
        closeModal();
      } catch (err) {
        console.error(err);
      }

    }





  };

    const handleCellChange = (index, key, newValue) => {
        const updatedData = [...tableData];

        console.log("Table Data: ",tableData);
        console.log("Updated Data: ",updatedData);
        console.log("Updated Data: ",updatedData[index]);
        console.log("Updated Data: ",newValue);
        updatedData[index] = parseInt(newValue, 10);;
        setTableData(updatedData)

        // Ensure the row exists
        /*if (!updatedData[rowIndex]) {
            updatedData[rowIndex] = {}; // create an empty object if it doesn't exist
        }

        updatedData[rowIndex][key] = newValue;
        setTableData(updatedData);*/
    };

  if (!modalOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-button" onClick={closeModal}>
          ×
        </button>
        <h3>{selectedTask.name} - {financialType}</h3>

        {loading ? (
          <div className="loading">Loading data...</div>
        ) : (
          <>
            <div className="scroll-container">
                <table className="modal-table">
                    <thead>
                        <tr>
                            <th>Header</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                    {tableHeaders&&tableHeaders.map((tableHeaders, index) => (
                        <tr>
                            <td key={index}>{tableHeaders}</td>
                            <td
                            contentEditable
                            suppressContentEditableWarning={true}
                            style={{
                                padding: "8px 12px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                                cursor: "text"
                            }}
                            onBlur={(e) => handleCellChange(index, tableHeaders, e.target.innerText)}
                            >
                            {tableData[index]}
                            </td>

                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="modal-footer">
              <button className="deny-button" onClick={closeModal}>
                Deny
              </button>
              <button className="approve-button" onClick={handleApprove}>
                Approve
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminModal;